import type {
  CreateNewsletterPostParams,
  NewsletterPost,
  NewsletterPostStatus,
  NewsletterPostsListResponse,
  UpdateNewsletterPostParams,
} from "@circle-react/types/Newsletter";

import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export interface ListNewsletterPostsParams {
  newsletterId: number;
  params?: {
    page?: number;
    per_page?: number;
    status?: NewsletterPostStatus;
    query?: string;
  };
}

const list = ({
  newsletterId,
  params = {},
}: ListNewsletterPostsParams): Promise<NewsletterPostsListResponse> =>
  reactQueryGet<NewsletterPostsListResponse>(
    internalApi.newsletterPosts.list({ newsletterId, params }),
  );

const create = ({
  newsletterId,
  body,
}: {
  newsletterId: number;
  body: CreateNewsletterPostParams;
}): Promise<NewsletterPost> =>
  reactQueryPost<
    NewsletterPost,
    { newsletter_post: CreateNewsletterPostParams }
  >(internalApi.newsletterPosts.create({ newsletterId }), {
    newsletter_post: body,
  });

const show = ({
  newsletterId,
  id,
}: {
  newsletterId: number;
  id: number;
}): Promise<NewsletterPost> =>
  reactQueryGet<NewsletterPost>(
    internalApi.newsletterPosts.show({ newsletterId, id }),
  );

const update = ({
  newsletterId,
  id,
  body,
}: {
  newsletterId: number;
  id: number;
  body: UpdateNewsletterPostParams;
}): Promise<NewsletterPost> =>
  reactQueryPut<
    NewsletterPost,
    { newsletter_post: UpdateNewsletterPostParams }
  >(internalApi.newsletterPosts.update({ newsletterId, id }), {
    newsletter_post: body,
  });

const destroy = ({
  newsletterId,
  id,
}: {
  newsletterId: number;
  id: number;
}): Promise<void> =>
  reactQueryDelete<void, object>(
    internalApi.newsletterPosts.destroy({ newsletterId, id }),
  );

const publish = ({
  newsletterId,
  id,
}: {
  newsletterId: number;
  id: number;
}): Promise<void> =>
  reactQueryPost<void, object>(
    internalApi.newsletterPosts.publish({ newsletterId, id }),
  );

const sendTest = ({
  newsletterId,
  id,
}: {
  newsletterId: number;
  id: number;
}): Promise<void> =>
  reactQueryPost<void, object>(
    internalApi.newsletterPosts.testEmail({ newsletterId, id }),
  );

export const newsletterPostsApi = {
  list,
  create,
  show,
  update,
  destroy,
  publish,
  sendTest,
};
